import { render, staticRenderFns } from "./CompeteProblem.vue?vue&type=template&id=98a0e58c&scoped=true&"
import script from "./CompeteProblem.vue?vue&type=script&lang=js&"
export * from "./CompeteProblem.vue?vue&type=script&lang=js&"
import style0 from "./CompeteProblem.vue?vue&type=style&index=0&id=98a0e58c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a0e58c",
  null
  
)

export default component.exports